import {
  GET_OPERATION_LOG_DATA, GET_USER_OPERATION_LIST_DATA, GET_EMAIL_OPERATION_LIST_DATA, GET_DEAL_OPERATION_LIST_DATA,
  GET_API_OPERATION_LIST_DATA, GET_REPORT_OPERATION_LIST_DATA, GET_ERROR_MESSAGE_LIST_DATA, GET_API_OPERATION_DATA,
  RESET_OPERATION_LOG_DATA, RESET_OPERATION_LOG_FILE_LINK,
} from '../../../constants/system/actions';

const getOperationLogData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_OPERATION_LOG_DATA, payload, resolve, reject,
});

const getUserOperationListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_USER_OPERATION_LIST_DATA, payload, resolve, reject,
});

const getEmailOperationListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_EMAIL_OPERATION_LIST_DATA, payload, resolve, reject,
});

const getDealOperationListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_DEAL_OPERATION_LIST_DATA, payload, resolve, reject,
});

const getApiOperationListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_API_OPERATION_LIST_DATA, payload, resolve, reject,
});

const getReportOperationListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_REPORT_OPERATION_LIST_DATA, payload, resolve, reject,
});

const getErrorMessageListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_ERROR_MESSAGE_LIST_DATA, payload, resolve, reject,
});

const getApiOperationData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_API_OPERATION_DATA, payload, resolve, reject,
});

const resetOperationLogData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_OPERATION_LOG_DATA, payload,
});

const resetOperationLogFileLink: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_OPERATION_LOG_FILE_LINK, payload,
});

export {
  getOperationLogData,
  getUserOperationListData,
  getEmailOperationListData,
  getDealOperationListData,
  getApiOperationListData,
  getReportOperationListData,
  getErrorMessageListData,
  getApiOperationData,
  resetOperationLogData,
  resetOperationLogFileLink,
};
